import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import { useBanner } from "../../../../providers/BannerProviders";
import YouTubeVideo from "../YoutubeAutoPlay";

const WhyWeGiveSection = () => {
  const { data } = useBanner();
  const homeBanner = data?.data?.find((item) => item?.bannerType === "home");

  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
      Toolbar: true,
    });
    return () => {
      Fancybox.unbind("[data-fancybox]");
    };
  }, []);

  return (
    <>
      <section className="relative flex w-full pb-24 lg:py-11 xls:py-24">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="space-y-10 sm:space-y-16">
            <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
              {homeBanner?.details?.videoSection?.title}
            </h2>

            <div className="relative">
              <YouTubeVideo
                videoUrl={homeBanner?.details?.videoSection?.link}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyWeGiveSection;
